import { makeAuthorBasedVerification } from '../makeVerification';

// Edit Profile
export const verifyEditProfile = makeAuthorBasedVerification(
  'edit_member_profile',
  'edit_member_profile_other'
);
